const BASE_URL = "https://radovic.com/sendemail";

export const sendEmail = async (messageText) => {
  const to = "info@zizipickleball.hr";
  const subject = "rezervation";
  const emailtext = encodeURIComponent(messageText);

  const url = `${BASE_URL}?to=${to}&subject=${subject}&emailtext=${emailtext}`;

  try {
    const response = await fetch(url, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error("Failed to send email");
    }

    const result = await response.text(); // or .json() if the server returns JSON
    return result;
  } catch (error) {
    console.error("Email sending error:", error);
    throw error;
  }
};
